import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";

const CustomSelectOption = ({
    label,
    name,
    value = [],
    onChange,
    options = [],
    error,
    touched,
    placeholder = "Select",
    onBlur,
}) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleToggle = (optionValue) => {
        const newValue = value.includes(optionValue)
            ? value.filter((v) => v !== optionValue)
            : [...value, optionValue];

        onChange({ target: { name, value: newValue } });

        if (onBlur) {
            onBlur({ target: { name } });
        }
    };

    const selectedLabels = options
        .filter((opt) => value.includes(opt.value))
        .map((opt) => opt.label)
        .join(", ");

    return (
        <div className="grid grid-cols-12 text-sm w-full md:py-4 py-2 items-start gap-4">
            {label && (
                <label
                    htmlFor={name}
                    className="col-span-12 sm:col-span-4 text-sm font-medium text-gray-700 mt-2"
                >
                    {label}
                </label>
            )}
            <div className="col-span-12 sm:col-span-8 relative" ref={dropdownRef}>
                <div
                    className={`w-full border p-3 rounded-lg cursor-pointer flex justify-between items-center ${touched && error ? "border-red-500" : "border-gray-300"
                        }`}
                    onClick={() => setOpen(!open)}
                >
                    <span className={selectedLabels ? "" : "text-gray-400"}>
                        {selectedLabels || placeholder}
                    </span>
                    <FiChevronDown className="text-gray-500" />
                </div>

                {open && (
                    <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded shadow-lg max-h-60 overflow-y-auto">
                        {options.map((opt) => (
                            <li
                                key={opt.value}
                                className="px-4 py-2 cursor-pointer flex items-center space-x-2 hover:bg-gray-50"
                                onClick={() => handleToggle(opt.value)}
                            >
                                <input
                                    type="checkbox"
                                    checked={value.includes(opt.value)}
                                    readOnly
                                    className="accent-green-600"
                                />
                                <span>{opt.label}</span>
                            </li>
                        ))}
                    </ul>
                )}

                {touched && error && (
                    <div className="text-red-500 text-xs mt-1">{error}</div>
                )}
            </div>
        </div>
    );
};

export default CustomSelectOption;
